import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Settings } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Breadcrumbs } from '@/components/layout/Breadcrumbs';
import { PageContainer } from '@/components/layout/PageContainer';
import { TeamInformationSection } from '@/components/forms/team/TeamInformationSection';
import { TeamStatsSection } from '@/components/forms/team/TeamStatsSection';
import { TeamPlayersSection } from '@/components/forms/team/TeamPlayersSection';

export const Route = createFileRoute('/dashboard/sports/$id/teams/new')({
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();
  const navigate = useNavigate();

  const sportName = id.toUpperCase();

  return (
    <PageContainer>
      <Breadcrumbs
        overrides={{ sports: 'Sports', [id]: id.toUpperCase() }}
        pathOverrides={{ sports: `/dashboard/sports/${id}` }}
      />
      <div className="flex gap-4 items-center mb-6 flex-wrap">
        <div className="flex items-center gap-2">
          <Settings className="h-5 w-5 text-gray-500" />
          <h1 className="text-2xl font-semibold">
            {sportName} {'>'} Teams {'>'} Add Team
          </h1>
        </div>

        <div className="flex gap-2 ml-auto">
          <Button
            variant="outline"
            onClick={() => navigate({ to: '/dashboard/sports/$id/teams', params: { id } })}
          >
            Cancel
          </Button>
          <Button className="bg-blue-600 hover:bg-blue-700 text-white" disabled>
            Save
          </Button>
        </div>
      </div>

      <div className="space-y-6">
        <TeamInformationSection sportName={sportName} disabled />

        <TeamStatsSection sport={sportName} />

        <TeamPlayersSection teamName="" sportName={sportName} onEdit={() => {}} />
      </div>
    </PageContainer>
  );
}
